/** Translator is an Explorer tool. Keep its route for history and access,
 * but exclude it from module launchers and module administration. */
export function filterModuleRoutes<T extends { id?: string; component?: string }>(
  routes: T[]
): T[] {
  return routes.filter((route) => route.id !== "translate" && route.component !== "translate")
}
